import $ from "jquery";

// Interface definitions
interface RankingTable {
  type: string;
  setQueryParams(params: QueryParams): void;
  setEntries(entries: RankingField[]): void;
  setIsLastTable(isLast: boolean): void;
  toHtml(): string;
}

interface RankingData {
  type: string;
  fields: RankingField[];
}

interface RankingField {
  [key: string]: any;
}

interface QueryParams {
  [key: string]: any;
}

declare global {
  interface Window {
    tablemill: any;
  }
}

class KeywordRankingView {
  private rankingTables: RankingTable[];
  private keywordRankingRoot: JQuery;
  private params: QueryParams | null = null;

  private static readonly LAST_TABLE_INDEX = 2;

  constructor(rankingTables: RankingTable[], keywordRankingRoot: JQuery) {
    this.rankingTables = rankingTables;
    this.keywordRankingRoot = keywordRankingRoot;
  }

  initialize(): void {
    this.showIndicator();
  }

  private showIndicator(): void {
    this.keywordRankingRoot.append('<div class="indicator gr" />');
  }

  private removeIndicator(): void {
    this.keywordRankingRoot.empty();
  }

  private rankingTableFor(type: string): RankingTable | undefined {
    return this.rankingTables.find((table) => table.type === type);
  }

  private renderTable(table: RankingTable): void {
    this.keywordRankingRoot.append(table.toHtml());
  }

  insertRankings(rankings: RankingData[], params: QueryParams): void {
    this.params = params;
    this.removeIndicator();

    if (rankings.length > 0) {
      rankings.forEach((ranking, index) => {
        const table = this.rankingTableFor(ranking.type);
        if (table) {
          table.setQueryParams(params);
          table.setEntries(ranking.fields);
          if (this.isLastTable(index)) {
            table.setIsLastTable(true);
          }
          this.keywordRankingRoot.append(table.toHtml());
        }
      });
      this.renderNoDataToRemainTables(rankings.map((ranking) => ranking.type));
    } else {
      this.renderNoDataToRemainTables([]);
    }
  }

  private isLastTable(index: number): boolean {
    return KeywordRankingView.LAST_TABLE_INDEX === index;
  }

  private renderNoDataToRemainTables(renderedTableTypes: string[]): void {
    const allTableTypes = this.rankingTables.map((ranking) => ranking.type);
    const remainingTypes = allTableTypes.filter(
      (type) => !renderedTableTypes.includes(type),
    );

    remainingTypes.forEach((type, index) => {
      const table = this.rankingTableFor(type);
      if (table) {
        table.setEntries([]);
        if (this.isLastTable(renderedTableTypes.length + index)) {
          table.setIsLastTable(true);
        }
        this.keywordRankingRoot.append(table.toHtml());
      }
    });
  }

  renderErrorMessage(message: string): void {
    this.removeIndicator();
    // HTMLエスケープ処理
    const escapedMessage = $("<div>").text(message).html();
    this.keywordRankingRoot.append(`<p class="error">${escapedMessage}</p>`);
  }

  showKeywordNotFoundMessage(keyword: string): void {
    const message = `「${keyword}」は見付かりませんでした。他のキーワードをお試し下さい。`;
    this.renderErrorMessage(message);
  }

  showBadPartitionMessage(partition: string): void {
    const message = `パーティション「${partition}」はサポートされていません。`;
    this.renderErrorMessage(message);
  }
}

// Global export
window.tablemill = window.tablemill || {};
window.tablemill.KeywordRankingView = KeywordRankingView;

export { KeywordRankingView };
